<template>
  <div>
    <div class="wrapper">
      <div class="animated fadeIn">
        <b-row>
          <b-col cols="12" class="mb-3">
            <b-button variant="primary" @click="$router.push('/admin/locations/toevoegen')" class="pull-right" v-can="'locaties aanpassen'">Locatie toevoegen
            </b-button>
            <b-button v-b-modal.import-locations class="pull-right mr-2" v-can="'locaties aanpassen'">Importeren
            </b-button>
          </b-col>
        </b-row>

        <resource-index header="Locaties" endpoint="locations" show-route="locations.view" />
      </div>
    </div>

    <b-modal id="import-locations" ref="import-locations" title="Importeren" hide-footer>
      <b-tabs content justified>
        <b-tab title="Locaties" active>
          <p class="mb-4">
            Importeer locaties aan de hand van een .XLSX document met daarin de volgende kolommen:
          </p>
          <b-list-group class="mt-0 mb-4">
            <b-list-group-item class="pt-1 pb-1 pl-3 pr-3">1. Locatiecode</b-list-group-item>
            <b-list-group-item class="pt-1 pb-1 pl-3 pr-3">2. Locatienaam</b-list-group-item>
            <b-list-group-item class="pt-1 pb-1 pl-3 pr-3">3. Adres</b-list-group-item>
            <b-list-group-item class="pt-1 pb-1 pl-3 pr-3">4. Postcode</b-list-group-item>
            <b-list-group-item class="pt-1 pb-1 pl-3 pr-3">5. Plaats</b-list-group-item>
            <b-list-group-item class="pt-1 pb-1 pl-3 pr-3">6. Landcode</b-list-group-item>
            <b-list-group-item class="pt-1 pb-1 pl-3 pr-3">7. Moederbedrijf naam</b-list-group-item>
            <b-list-group-item class="pt-1 pb-1 pl-3 pr-3">8. Interne referentie</b-list-group-item>
          </b-list-group>
          <b-form id="upload-form" @submit.prevent="importLocations">
            <b-form-file v-model="locationsFile" :state="Boolean(locationsFile)" accept=".xls, .xlsx, .csv, .txt" placeholder="Kies of sleep een bestand..." drop-placeholder="Sleep het bestand..." />
            <b-row class="mt-2">
              <b-col>
                <hr>
                <b-button type="submit" :disabled="!locationsFile" block class="mt-4" variant="primary">Importeer</b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-tab>
        <b-tab title="Transportdagen" v-can="'transportschema aanpassen'">
          <p class="mb-4">
            Importeer transportdagen instellingen aan de hand van een .XLSX document met daarin de volgende kolommen:
          </p>
          <b-list-group class="mt-0 mb-4">
            <b-list-group-item class="pt-1 pb-1 pl-3 pr-3">1. Locatiecode</b-list-group-item>
            <b-list-group-item class="pt-1 pb-1 pl-3 pr-3">2. Locatienaam</b-list-group-item>
            <b-list-group-item class="pt-1 pb-1 pl-3 pr-3">3. Adres</b-list-group-item>
            <b-list-group-item class="pt-1 pb-1 pl-3 pr-3">4. Postcode</b-list-group-item>
            <b-list-group-item class="pt-1 pb-1 pl-3 pr-3">5. Plaats</b-list-group-item>
            <b-list-group-item class="pt-1 pb-1 pl-3 pr-3">6. Maandag</b-list-group-item>
            <b-list-group-item class="pt-1 pb-1 pl-3 pr-3">7. Dinsdag</b-list-group-item>
            <b-list-group-item class="pt-1 pb-1 pl-3 pr-3">8. Woensdag</b-list-group-item>
            <b-list-group-item class="pt-1 pb-1 pl-3 pr-3">9. Donderdag</b-list-group-item>
            <b-list-group-item class="pt-1 pb-1 pl-3 pr-3">10. Vrijdag</b-list-group-item>
            <b-list-group-item class="pt-1 pb-1 pl-3 pr-3">11. Zaterdag</b-list-group-item>
            <b-list-group-item class="pt-1 pb-1 pl-3 pr-3">12. Startdatum (dd-mm-jjjj)</b-list-group-item>
            <b-list-group-item class="pt-1 pb-1 pl-3 pr-3">13. Op afroep</b-list-group-item>
            <b-list-group-item class="pt-1 pb-1 pl-3 pr-3">14. Schema startweek</b-list-group-item>
          </b-list-group>
          <b-form id="upload-form" @submit.prevent="importTransport">
            <b-form-file v-model="transportFile" :state="Boolean(transportFile)" accept=".xls, .xlsx, .csv, .txt" placeholder="Kies of sleep een bestand..." drop-placeholder="Sleep het bestand..." />
            <b-row class="mt-2">
              <b-col>
                <hr>
                <b-button type="submit" :disabled="!transportFile" block class="mt-4" variant="primary">Importeer</b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-tab>
      </b-tabs>
    </b-modal>
  </div>
</template>
<script>
import ResourceIndex from '../../components/ResourceIndex';
import { uploadData } from "../../api";

export default {
  name: 'locations',
  components: { ResourceIndex },
  data() {
    return {
      transportFile: undefined,
      locationsFile: undefined,
    }
  },
  methods: {
    openImportModal() {
      this.$refs['import-holidays'].show()
    },
    hideImportModal() {
      this.$refs['import-holidays'].hide();
    },
    async importTransport() {
      let data = new FormData();
      const file = this.transportFile;
      data.append('file', file);

      let response = await uploadData('locations/renewal-settings/import', data);
      if (response.status === 422) {
        this.$bvToast.toast(`${response.data.errors[0][0]}`, {
          title: 'Oeps...',
          noAutoHide: true,
          variant: 'danger',
        });
      } else if (response.status !== 200) {
        this.$bvToast.toast(`Er is iets fout gegaan tijdens het importeren: ${response.data.message}`, {
          title: 'Oeps...',
          autoHideDelay: 5000,
          variant: 'danger',
        });
      } else if (response.status === 200) {
        this.$bvToast.toast(`Importeren van transportdagen is gelukt`, {
          title: 'Succes',
          autoHideDelay: 5000,
          variant: 'success',
        });
      }

      this.transportFile = undefined;
      this.hideImportModal();
    },
    async importLocations() {
      let data = new FormData();
      const file = this.locationsFile;
      data.append('file', file);

      const response = await uploadData('locations/import', data);

      if (response.status === 422) {
        this.$bvToast.toast(`${response.data.errors[0][0]}`, {
          title: 'Oeps...',
          noAutoHide: true,
          variant: 'danger',
        });
      } else if (response.status !== 200) {
        this.$bvToast.toast(`Er is iets fout gegaan tijdens het importeren: ${response.data.message}`, {
          title: 'Oeps...',
          autoHideDelay: 5000,
          variant: 'danger',
        });
      } else if (response.status === 200) {
        this.$bvToast.toast(`Importeren van locaties is gelukt`, {
          title: 'Succes',
          autoHideDelay: 5000,
          variant: 'success',
        });
      }

      this.locationsFile = undefined;
      this.hideImportModal();
    },
  },
}

</script>
